<template lang="pug">
.study-result-resolve-list
  //- サイドメニュー部
  side-menu.study-result-resolve-list__side-menu(
    :userRole='userRole',
    :currentLink='currentLink',
    :linkEvent='sideMenuLinkEvent',
    :logoutEvent='logoutEvent'
  )
    template(#separateText)
      slot(name='sideMenuSeparateText')
    template(#logoutText)
      slot(name='logoutText')
  //- コンテンツ表示部
  .study-result-resolve-list__content
    breadcrumb-list.study-result-resolve-list__content__breadcrumb(
      :breadcrumbs='breadcrumbs',
      :moveEvent='breadcrumbMoveEvent'
    )
    //- キャプチャ画像一覧表示
    .study-result-resolve-list__content__body__image-block(v-if='images')
      .study-result-resolve-list__content__body__image-block__heading
        tab-heading.study-result-resolve-list__content__body__image-block__heading__tab(:isActive='true')
          slot(name='imageListLabel')
      .study-result-resolve-list__content__body__image-block__main
        .study-result-resolve-list__content__body__image-block__main__images
          study-result-detail-image-list.study-result-resolve-list__content__body__image-block__main__images__list(
            :userRole='userRole',
            :images='images',
            :clickEvent='openImageModal'
          )
    //- 結果情報一覧表示
    .study-result-resolve-list__content__body__table-block
      .study-result-resolve-list__content__body__table-block__heading
        tab-heading.study-result-resolve-list__content__body__table-block__heading__tab(:isActive='true') {{ titleText }}
      .study-result-resolve-list__content__body__table-block__main
        study-result-resolve-table.study-result-resolve-list__content__body__table-block__main__table(
          :studyResultResolves='studyResultResolves'
        )
          template(#problemNumberHeader)
            slot(name='problemNumberHeader')
          template(#questionNumberHeader)
            slot(name='questionNumberHeader')
          template(#questionTypeHeader)
            slot(name='questionTypeHeader')
          template(#correctAnswerHeader)
            slot(name='correctAnswerHeader')
          template(#correctSymbolHeader)
            slot(name='correctSymbolHeader')
          template(#resolveCorrectSymbolHeader)
            slot(name='resolveCorrectSymbolHeader')
  //- モーダル部
  modal-study-result-image.study-result-detail__modal(
    ref='modalStudyResultImage',
    :title='modalTitle',
    :imageUrl='modalImageUrl'
  )
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import SideMenu from '@/components/organisms/manager/SideMenu.vue'
import BreadcrumbList from '@/components/organisms/manager/BreadcrumbList.vue'
import TabHeading from '@/components/molecules/manager/TabHeading.vue'
import StudyResultDetailImageList from '@/components/organisms/manager/StudyResultDetailImageList.vue'
import StudyResultResolveTable from '@/components/organisms/manager/StudyResultResolveTable.vue'
import ModalStudyResultImage from '@/components/organisms/manager/ModalStudyResultImage.vue'
import { breadcrumbType } from '@/models/breadcrumbModel'
import { StudyResultDetailImage, StudyResultResolveType } from '@/models/studyResultDetailModel'
import { LinkSetting } from '@/const/SideMenuSettings'
import { UserRoles } from '@/const/UserRoles'

/**
 * 履歴管理・生徒の成績表解きなおし画面
 */
@Component({
  components: {
    SideMenu,
    BreadcrumbList,
    TabHeading,
    StudyResultDetailImageList,
    StudyResultResolveTable,
    ModalStudyResultImage,
  },
})
export default class StudyResultResolveList extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // このページのリンク設定
  @Prop()
  currentLink!: LinkSetting

  // サイドメニューリンク押下時のイベント
  @Prop()
  sideMenuLinkEvent!: Function

  // ログアウトボタン押下時のイベント
  @Prop()
  logoutEvent!: Function

  // パンくず一覧情報
  @Prop()
  breadcrumbs!: breadcrumbType[]

  // パンくず遷移イベント
  @Prop()
  breadcrumbMoveEvent!: Function

  // キャプチャ画像一覧情報
  @Prop()
  images!: StudyResultDetailImage[]

  // 画像一覧クリック時イベント
  @Prop()
  imageListClickEvent!: Function

  // タブに表示するタイトル
  @Prop()
  titleText!: string

  // テスト結果解きなおし詳細表示情報
  @Prop()
  studyResultResolves!: StudyResultResolveType[]

  // モーダルタイトル
  @Prop()
  modalTitle!: string

  // モーダルに表示する画像URL
  @Prop()
  modalImageUrl!: string

  // モーダルref
  @Ref()
  modalStudyResultImage!: ModalStudyResultImage

  // 画像モーダルを開く
  private async openImageModal(image: StudyResultDetailImage) {
    await this.imageListClickEvent(image)
    if (this.modalImageUrl) {
      this.modalStudyResultImage.show()
    }
  }
}
</script>

<style lang="stylus" scoped>
.study-result-resolve-list
  display flex
  width 100%
  height 100%

  &__content
    width calc(100% - 263px)
    height 100%
    display flex
    flex-direction column
    padding 40px
    gap 10px

    &__body
      display flex
      flex-direction column
      min-height 0
      width 100%

      &__image-block
        height 270px
        &__heading
          display flex
          height 43px
          &__tab
            box-shadow none !important

        &__main
          z-index 1
          width 100%
          display flex
          flex-direction column
          border-radius 0px 15px 15px 15px
          background var(--color-manager-list__background)
          box-shadow 0px 3px 5px 0px var(--color-manager-list__shadow)
          height 220px

          &__images
            width 100%
            display flex
            padding 10px 20px
            height 220px

            &__list
              width 97%
              margin 0 auto

      &__table-block
        flex 1
        display flex
        flex-direction column
        min-height 0

        &__heading
          display flex
          height 43px
          &__tab
            box-shadow none !important

        &__main
          flex 1
          z-index 1
          width 100%
          display flex
          flex-direction column
          border-radius 0px 15px 15px 15px
          background var(--color-manager-list__background)
          box-shadow 0px 3px 5px 0px var(--color-manager-list__shadow)
          overflow-y auto

          &__table
            margin 20px 0 40px 0
</style>
